// Import components
import CreateButton from "global/components/CreateButton";

// Import css
import "global/components/NumberStepperInput.css";



// Function to render a reusable number stepper input
const NumberStepperInput = ({
    disabled = false,
    name = "",
    ariaLabelMinus = "Decrease value",
    ariaLabelPlus = "Increase value",
    step = 1,
    min = 0,
    max,
    value,
    onChange,
    onBlur,
    placeholder = "0",
    rightLabel = "",
    leftLabel = "",
}) => {



    // Function to safely update the value by step amount
    const handleStepperClick = (stepAmount) => {

        // Stop if the input is disabled
        if (disabled) {

            // Return early
            return;

        }

        // Convert current value to a number
        const currentValue = Number(value || 0);

        // Create the next value
        let nextValue = currentValue + stepAmount;

        // Stop value going below minimum
        if (min !== undefined) {

            // Apply minimum value
            nextValue = Math.max(min, nextValue);

        }

        // Stop value going above maximum
        if (max !== undefined) {

            // Apply maximum value
            nextValue = Math.min(max, nextValue);

        }

        // Create a fake event so this works with normal handleChange functions
        const event = {
            target: {
                name,
                value: nextValue,
            },
        };

        // Trigger parent change handler
        onChange(event);

    };



    // Function to handle keyboard input
    const handleKeyDown = (event) => {

        // Check for the up arrow key
        if (event.key === "ArrowUp") {

            // Prevent the browser default behaviour
            event.preventDefault();

            // Increase the value
            handleStepperClick(step);

            // Stop here
            return;

        }

        // Check for the down arrow key
        if (event.key === "ArrowDown") {

            // Prevent the browser default behaviour
            event.preventDefault();

            // Decrease the value
            handleStepperClick(-step);

            // Stop here
            return;

        }

    };



    return (

        <div className="numberStepperInput">

            <CreateButton
                title="-"
                type="button"
                plain={true}
                size="xs"
                disabled={disabled}
                onClick={() => handleStepperClick(-step)}
                aria-label={ariaLabelMinus}
            />

            <label className="numberStepperInput__field">

                {leftLabel ? (

                    <span className="numberStepperInput__label">
                        {leftLabel}
                    </span>

                ) : null}

                <input
                    name={name}
                    type="text"
                    inputMode="numeric"
                    min={min}
                    max={max}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    onKeyDown={handleKeyDown}
                    className="numberStepperInput__input"
                    placeholder={placeholder}
                    disabled={disabled}
                />

                {rightLabel ? (

                    <span className="numberStepperInput__label">
                        {rightLabel}
                    </span>

                ) : null}

            </label>

            <CreateButton
                title="+"
                type="button"
                plain={true}
                size="xs"
                disabled={disabled}
                onClick={() => handleStepperClick(step)}
                aria-label={ariaLabelPlus}
            />

        </div>

    );

};

export default NumberStepperInput;